export default "__VITE_ASSET__4YuQh2$w__"